/** Context and hook, split from the provider so the module exports components only. */

import { createContext, useContext } from 'react'

export interface ToastApi {
  /** `note` adds a second line and keeps the toast up longer, so it gets read. */
  success(title: string, body?: string, note?: string): void
  error(title: string, body?: string): void
}

export const ToastContext = createContext<ToastApi | null>(null)

export function useToasts(): ToastApi {
  const context = useContext(ToastContext)
  if (!context) throw new Error('useToasts must be used inside <ToastProvider>')
  return context
}
